import React, { useContext, useState } from 'react';
import AuthContext from '../../../contexts/AuthContext';
import ModalPage from '../../ModalPage';
import AuthenticatorAuthSetup from './AuthenticatorAuthSetup';
import SMSAuthSetup from './SMSAuthSetup';

export default function TwoFactorAuthSetup () {
    const [type, setType] = useState('AUTHENTICATOR');
    const { onLogout } = useContext(AuthContext);

    return (
        <ModalPage
            title="Set up 2-Factor authentication"
            style={{ backgroundColor: '#485CC7' }}
        >
            <div>
                <img
                    style={{ width: 70, height: 70, marginTop: 5, marginBottom: 20, marginLeft: 'auto', marginRight: 'auto', display: 'block' }}
                    src={require('../../../images/lock.png')}
                    alt="Lock icon"
                />
                <div style={{ fontSize: 16, fontWeight: 'normal', lineHeight: 1.4, textAlign: 'center', marginBottom: 40 }}>
                    Keep your account secure by setting up 2-factor authentication.<br/>This will require a smart phone or a device that can receive SMS messages.
                </div>
                <div style={{ marginBottom: 20 }}>
                    <div style={{ display: 'flex', flexDirection: 'column', fontSize: 14 }}>
                        <div style={{ fontWeight: 600, marginBottom: 10 }}>
                            <label>Select a method:</label>
                        </div>
                        <div style={{ flex: 1 }}>
                            <label>
                                <input
                                    type='radio'
                                    name="type"
                                    value='AUTHENTICATOR'
                                    checked={type === 'AUTHENTICATOR'}
                                    onChange={(e) => setType(e.target.value)}
                                />
                                Authenticator App (Recommended)
                            </label>
                            <br/>
                            <label>
                                <input
                                    type='radio'
                                    name="type"
                                    value='SMS'
                                    checked={type === 'SMS'}
                                    onChange={(e) => setType(e.target.value)}
                                />
                                SMS
                            </label>
                        </div>
                    </div>
                </div>
                {type === 'AUTHENTICATOR' ? <AuthenticatorAuthSetup /> : <SMSAuthSetup />}
            </div>
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', marginTop: 20}}>
                {/* eslint-disable-next-line */}
                <a href="#" onClick={(e)=>{
                    e.preventDefault();
                    onLogout();
                }} style={{fontSize: 14, textDecoration: 'none'}}>Go back to login</a>
            </div>
        </ModalPage>
    );
};